<template>
  <transition name="pcg-modal__transition">
    <div class="pcg-modal" v-if="isOpen" :class="classes" >
      <div class="pcg-modal__backdrop" @click="clickOutside"></div>
      <div class="mx-auto pcg-modal__content-wrapper">
        <div class="pcg-modal__box" :style="pcgThemeStyle">
          <button v-if="closeable" class="pcg-modal__close" @click="$emit('update:isOpen', false)">
            <span>&times;</span>
          </button>
          <scrollbars>
            <div style="overflow-x: hidden">
              <div class="pcg-modal__body">
                <slot />
                <div v-if="showsMsg" v-html="modalMsg" class="pcg-modal__msg"></div>
              </div>
              <div class="pcg-modal__footer d-flex justify-content-end">
                <slot name="footer"/>
              </div>
            </div>
          </scrollbars>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Scrollbars from "@/components/Scrollbars/Scrollbars";
import {modalMsg} from "@/components/Modal/modalUtils";
import {computed} from "@vue/reactivity";
import {pcgThemeStyle} from "../../utils/globals";

export default {
  name: "Modal",
  components: {Scrollbars},
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default: true
    },
    /* use this modal to show messages from modalUtils */
    showsMsg: {
      type: Boolean,
      default: false
    },
    autoPadding: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:isOpen'],
  setup(props, {emit}) {
    const clickOutside = () => {
      if (props.closeable === true) {
        emit('update:isOpen', false);
      }
    };

    const classes = computed(() => ({
      'pcg-modal--auto-padding': props.autoPadding
    }));

    return {
      clickOutside,
      modalMsg,
      classes,
      pcgThemeStyle
    };
  }
}
</script>

<style lang="scss">
.pcg-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  $transition-duration: 0.3s;

  &__transition {
    &-enter-active, &-leave-active {
      transition: all $transition-duration;
    }

    &-enter-from, &-leave-to {
      opacity: 0;
      filter: blur(5px);
      transform: scale(1.3);
    }
  }

  &__backdrop {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }

  &__content-wrapper {
    max-width: 600px;
  }

  &__box {
    $boxMargin: 13px;
    position: relative;
    margin: $boxMargin;
    max-height: calc(100vh - #{$boxMargin * 2});
    background-color: white;
    border-radius: 2px;
    box-shadow: #00000073 0 0 10px;
  }

  &--auto-padding &__body {
    padding: 15px;
  }

  &__footer {
    border-top: 1px solid #dee2e6;
    padding: 12px;

    > * {
      margin: .25rem;
    }
  }

  &__close {
    font-size: 1.5rem;
    line-height: 1;
    text-shadow: 0 1px 0 #fff;

    position: absolute;
    z-index: 20;
    background-color: rgb(62 62 62);
    box-shadow: #00000052 2px 2px 5px;
    color: white;
    height: 30px;
    width: 30px;
    padding: 0 0 4px;
    border-radius: 50px;
    border: none;
    right: 17px;
    top: 17px;
    transition: background-color 200ms;

    &:hover {
      background-color: #9f3e3e;
    }
  }
}
</style>